const PrintTls = {

  makePrintable() {
    document.body.className = "A4 landscape printable";

    var noPrintArr = document.getElementsByClassName('no-print');
    for (let i = 0; i < noPrintArr.length; i++) {
      noPrintArr[i].classList.add('d-none');
    }


    // TODO add sheet to print
    // TODO remove all other
  },
  escPrintable() {
    document.body.className = "";
  
    var noPrintArr = document.getElementsByClassName('no-print');
    for (let i = 0; i < noPrintArr.length; i++) {
      noPrintArr[i].classList.remove('d-none');
    }


    // TODO add sheet to print
    // TODO remove all other
  }
}


export { PrintTls };